import {
  PathParamError,
  createFileRoute,
  redirect,
} from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { statusScreenSchema } from 'router/params/statusScreen';
import { beforeLoadSignupSubRoute, headSignupSubRoute } from 'router/utils';
import { resolveStatusScreen } from 'router/validateLeadStatus';
import { z } from 'zod';

const StatusScreenParamsSchema = z.object({
  statusScreen: statusScreenSchema,
});

export const Route = createFileRoute('/_signup/status/$statusScreen')({
  params: zodValidator(StatusScreenParamsSchema),
  head: headSignupSubRoute,
  onError: err => {
    if (err instanceof PathParamError) {
      throw redirect({ to: '/status', replace: true });
    }
  },
  beforeLoad: ({ context, location, preload, cause, params }) =>
    beforeLoadSignupSubRoute({
      context,
      location,
      preload,
      cause,
      validation: {
        validate: ({ lead }) => !!lead?.businessEmail,
        redirectTarget: '/',
      },
      validateLeadStatus: (leadStatus, leadStatusReason) => {
        if (
          resolveStatusScreen(leadStatus, leadStatusReason) !==
          params.statusScreen
        ) {
          throw redirect({ to: '/status', replace: true });
        }

        return { shouldRedirect: false };
      },
    }),
});
